export default __webpack_public_path__ + "static/media/2110.ce8bfa0f.png";